import $ from 'jquery'

$(document).ready(dhsv_vc_color_circles())

function dhsv_vc_color_circles() {
  const circlesNode = $('.dhsv_vc_color_circles')
  if (circlesNode.length) {
    const circlesOffsetTop = circlesNode.offset().top
    const circlesHeight = circlesNode.height()
    $(window).scroll(function() {
      const scrollTop = $(window).scrollTop()
      if (scrollTop > circlesOffsetTop + circlesHeight - 100) {
        circlesNode.addClass('sticky')
        circlesNode.closest('.vc_section').css('z-index', '2')
      } else {
        circlesNode.removeClass('sticky')
        circlesNode.closest('.vc_section').css('z-index', 'auto')
      }
    })
  }
}
